<template>
  <div class="form1">
    <div class="page_form">
      <el-form label-width="200px" size="small">
        <el-form-item label="活动名称">
          <el-input class="input_box" v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="活动时间">
          <el-date-picker
            v-model="formData.time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="助力成功奖励">
          <el-checkbox-group v-model="formData.sendType">
            <el-checkbox label="coupon" class="block_checkbox">
              <span style="margin-right: 15px">优惠券</span>
              <div class="padding10">
                <el-tag
                  v-for="(tag, index) in sList"
                  :key="tag.id"
                  closable
                  @close="delTagItem(index)"
                  style="margin-bottom:5px;margin-right:5px;"
                >
                  {{ tag.name }}
                  <span v-if="tag.choseNum != 1">
                    <span class="colorRed">×</span>
                    {{ tag.choseNum }} 张</span
                  >
                </el-tag>
              </div>
              <el-button @click="showSelecter = true">选择优惠券</el-button>
            </el-checkbox>
            <el-checkbox label="point" class="block_checkbox">积分
              <el-input v-model="formData.point" class="small_input"></el-input>
            </el-checkbox>
            <el-checkbox label="balance" class="block_checkbox">余额
              <el-input v-model="formData.balance" class="small_input"></el-input>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="助力成功条件">
          <el-radio-group v-model="formData.query">
            <el-radio label="1">完成消费</el-radio>
            <el-radio label="2">新会员</el-radio>
            <el-radio label="3">老会员</el-radio>
            <el-radio label="4">不限制</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="参与限制">
          <div class="block_checkbox">一个会员一天参与次数
            <el-input class="small_input" v-model="formData.limit_num1"></el-input>次
          </div>
          <div class="block_checkbox">
            活动期间一共有
            <el-input class="small_input" v-model="formData.limit_num2"></el-input>次
          </div>
          <div class="block_checkbox">
            活动期间给一个人助力
            <el-input class="small_input" v-model="formData.limit_num3"></el-input>次
          </div>
        </el-form-item>
      </el-form>
      <el-form label-width="200px">
        <el-form-item>
          <div style="margin-top: 10px">
            <el-button>返回</el-button>
            <el-button type="primary" @click="nextStep()">下一步</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <newSelectCommodityNum
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="2"
      ></newSelectCommodityNum>
    </el-dialog>
  </div>
</template>
<script>
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
export default {
  components: {
    newSelectCommodityNum
  },
  data(){
    return{
      formData: {
        name: "",
        time: [],
        point: "",
        balance: "",
        sendType: [],
        query: "",
        limit_num1: "",
        limit_num2: "",
        limit_num3: "",
      }, // 页面设置
      showSelecter: false,
      sList: [],
    }
  },
  methods:{
    nextStep(){
      this.$emit('nextStep')
    },
    //选择优惠券
    getCommod(data) {
      console.log(data);
      this.sList = data;
      this.showSelecter = false;
    },
    //删除选择的优惠券
    delTagItem(i) {
      console.log(i);
      this.sList.splice(i, 1);
    },
  }
}
</script>
<style lang="scss" scoped>
.page_form{
  margin-top: 20px;
  .form_title{
    border-top: 1px solid #EBEEF5;
    // border-bottom: 1px solid #EBEEF5;
    line-height: 47px;
    color: #303133;
    font-size: 13px;
    margin-bottom: 20px;
  }
  .input_box{
    width: 400px;
  }
  .block_checkbox{
    display: block;
    margin-bottom: 10px;
  }
  .small_input{
    width: 70px;
    margin: 0 5px;
  }
}
.padding10 {
  padding: 0 10px;
  display: inline-block;
}
</style>